import React from "react";

import R from "ramda";

import { Box, Flex, H4, H5, Image, Markup, A } from "src/components";

const Bio = ({ link, theme, name, title, photo, description, ...props }) => (
  <Flex
    mb={2}
    {...props}
    align={["center", null, null, "flex-start"]}
    flexDirection={["column", null, null, "row"]}
  >
    {photo && (
      <Image
        resolutions={photo.resolutions}
        alt={photo.description || photo.title || title}
        mr={3}
        mb={2}
      />
    )}
    <Box>
      <H4 style={{ margin: 0 }}>
        <A href={link} color="link" fontSize="inherit" fontWeight="inherit">
          {name}
        </A>
      </H4>
      <H5 style={{ margin: 0 }}>{title}</H5>
      <Markup html={R.path(["childMarkdownRemark", "html"], description)} />
    </Box>
  </Flex>
);

export default Bio;

export const BioFragment = graphql`
  fragment Bio on ContentfulBio {
    id
    __typename
    name
    title
    link
    description {
      childMarkdownRemark {
        html
      }
    }
    photo {
      resolutions(width: 120, height: 120, quality: 80) {
        ...GatsbyContentfulResolutions_withWebp
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content/Bio.js